import { observer } from "mobx-react-lite";
import UserModalStore, { PermissionThatCanBeGiven } from "core/stores/user-modal.store";
import Checkbox from "./checkbox";

type UserPermissionCheckboxProps = {
    item: PermissionThatCanBeGiven
}

type UserPermissionCheckboxesProps = {
    handlePermissionChange: any,
    handleAllCheckboxChange: any,
    modalStore: UserModalStore
}

const UserPermissionCheckboxes = observer((props: UserPermissionCheckboxesProps) => {
    const {
        handleAllCheckboxChange,
        handlePermissionChange,
        modalStore
    } = props;

    const UserPermissionCheckbox = (props: UserPermissionCheckboxProps) => {
        if (!props?.item) {
            return null;
        }

        const { isEnabled, name } = props.item;

        const onChange = (isChecked: boolean) => {
            handlePermissionChange(isChecked, props.item);
        }

        return (
            <li className={!isEnabled ? "disabled" : undefined}>
                <Checkbox
                    onChange={onChange}
                    defaultChecked={props.item.isChecked}
                    disabled={modalStore.areAllPermissionsSelected || !isEnabled} />
                <label className="for-cb">{name}</label>
            </li>
        );
    }

    return (
        <ul className="user-permissions">
            <li>
                <span className="all-wrapper">
                    <Checkbox
                        onChange={handleAllCheckboxChange}
                        defaultChecked={modalStore.areAllPermissionsSelected} />
                    <label className="for-cb">All</label>
                </span>

                <ul>
                    {modalStore.permissions.map((x, ix) => <UserPermissionCheckbox
                        key={ix}
                        item={x} />)}
                </ul>
            </li>
        </ul>
    );
});

export default UserPermissionCheckboxes;
